import React, { Suspense, lazy } from "react";
import { useRoutes } from "react-router-dom";
import SideNavbar from "../components/SideNavbar";
import ContentOverlayNew from "../components/content_overlay_new";
import ScrollToTop from "../components/Scrolltop";

const Introduction = lazy(() => import("./sections/IntroductionSection"));
const LiteratureReview = lazy(() => import("./sections/LiteratureReview"));
const Methods = lazy(() => import("./sections/methods/MethodsSection"));
const Results = lazy(() => import("./sections/results/ResultsSection"));
const Conclusion = lazy(() => import("./sections/ConclusionSection"));
const References = lazy(() => import("./sections/ReferencesSection"));
const StudyArea = lazy(() => import("./sections/study_area/StudyArea"));
const Study_Area_micro = lazy(() => import("./sections/study_area/StudyArea(micro_level_study)"));
const Method_micro_level=lazy(() => import("./sections/methods/Method(for_micro_level_study)"));
const Discussion = lazy(() => import("./sections/Discussion"));
const Materials= lazy(() => import("./sections/materials/Materials"));
const Data_used_micro= lazy(() => import("./sections/materials/DataUsed(micro_study)"));
const Western_Himalayan_Region=lazy(() => import("./sections/results/western_himalayan_region"));
const Eastern_Himalayan_Region=lazy(() => import("./sections/results/eastern_himalayan_region"));
const Lower_Gangetic_Plain_Region=lazy(() => import("./sections/results/lower_gangetic_plain"));
const Middle_Gangetic_Plain_Region=lazy(() => import("./sections/results/middle_gangetic_plain"));
const Upper_Gangetic_Plain_Region=lazy(() => import("./sections/results/upper_gangetic_plain"));
const Trans_Gangetic_Plain_Region=lazy(() => import("./sections/results/trans_gangetic_plain"));
const Eastern_Plateau_and_Hills_Region=lazy(() => import("./sections/results/eastern_plateau_and_hills"));
const Central_Plateau_and_Hills_Region=lazy(() => import("./sections/results/central_plateau_and_hills"));
const Western_Plateau_and_Hills_Region=lazy(() => import("./sections/results/western_plateau_and_hills"));
const Southern_Plateau_and_Hills_Region=lazy(() => import("./sections/results/southern_plateau_and_hills"));
const East_Cost_Plain_and_Hills_Region=lazy(() => import("./sections/results/east_cost_plain_and_hills"));
const West_Cost_Plain_and_Hills_Region=lazy(() => import("./sections/results/west_cost_plain_and_hills"));
const Western_Dry_Region=lazy(() => import("./sections/results/western_dry"));
const Gujrat_Plain_and_Hills_Region=lazy(() => import("./sections/results/gujrat_plain_and_hills"));
const Results_micro_level_study=lazy(() => import("./sections/results/results(micro_level_study)"));


const routes = [
    { path: "/", element: <Introduction /> },
    { path: "IntroductionSection", element: <Introduction /> },
    { path: "LiteratureReview", element: <LiteratureReview /> },
    { path: "StudyArea", element: <StudyArea /> },
    { path: "StudyArea(micro_level_study)", element: <Study_Area_micro /> },
    { path: "Materials", element: <Materials /> },
    { path: "DataUsed(micro_study)", element: <Data_used_micro /> },
    { path: "MethodsSection", element: <Methods /> },
    { path: "Method(for_micro_level_study)", element: <Method_micro_level /> },
    { path: "ResultsSection", element: <Results /> },
    { path: "western_himalayan_region", element: <Western_Himalayan_Region /> },
    { path: "eastern_himalayan_region", element: <Eastern_Himalayan_Region /> },
    { path: "lower_gangetic_plain", element: <Lower_Gangetic_Plain_Region /> },
    { path: "middle_gangetic_plain", element: <Middle_Gangetic_Plain_Region /> },
    { path: "upper_gangetic_plain", element: <Upper_Gangetic_Plain_Region /> },
    { path: "trans_gangetic_plain", element: <Trans_Gangetic_Plain_Region /> },
    { path: "eastern_plateau_and_hills", element: <Eastern_Plateau_and_Hills_Region /> },
    { path: "central_plateau_and_hills", element: <Central_Plateau_and_Hills_Region /> },
    { path: "western_plateau_and_hills", element: <Western_Plateau_and_Hills_Region /> },
    { path: "southern_plateau_and_hills", element: <Southern_Plateau_and_Hills_Region /> },
    { path: "east_cost_plain_and_hills", element: <East_Cost_Plain_and_Hills_Region /> },
    { path: "west_cost_plain_and_hills", element: <West_Cost_Plain_and_Hills_Region /> },
    { path: "western_dry", element: <Western_Dry_Region /> },
    { path: "gujrat_plain_and_hills", element: <Gujrat_Plain_and_Hills_Region /> },
    { path: "results(micro_level_study)", element: <Results_micro_level_study /> },
    { path: "Discussion", element: <Discussion /> },
    { path: "ConclusionSection", element: <Conclusion /> },
    { path: "ReferencesSection", element: <References /> },
  ];

function ArticlePage() {
    const routing = useRoutes(routes);
  
    return (
      <div className="article-layout">
        <div className="row">
          <div className="col-3">
            <SideNavbar />
          </div>
  
          <div className="col-9">
          <ScrollToTop />
            <Suspense fallback={<div>Loading content...</div>}>
            
              <ContentOverlayNew text_content={routing} />
            </Suspense>
          </div>
        </div>
      </div>
    );
  }
  export default ArticlePage;